import { SelectOption } from '@fleet-beat/core';

export enum FuelType {
  Diesel = 0,
  Gas = 1,
  Electric = 2,
  Ethanol = 3,
  Propane = 4,
}

export type VehicleFuelType = 'diesel' | 'gas' | 'electric' | 'ethanol' | 'propane';

export enum VehicleFuelTypeEnum {
  Diesel = 'diesel',
  Gas = 'gas',
  Electric = 'electric',
  Ethanol = 'ethanol',
  Propane = 'propane',
}

export const VehicleFuelTypeOptions: SelectOption[] = [
  { value: VehicleFuelTypeEnum.Diesel, label: 'Diesel' },
  { value: VehicleFuelTypeEnum.Gas, label: 'Gas' },
  { value: VehicleFuelTypeEnum.Electric, label: 'Electric' },
  { value: VehicleFuelTypeEnum.Ethanol, label: 'Ethanol' },
  { value: VehicleFuelTypeEnum.Propane, label: 'Propane' },
];
